


































































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import { mapGetters, mapState } from 'vuex';
import { notify } from '@/web/utils/notify';
import { errorToMessage } from '@/core/utils/errors';
import TaxRateDialog from '@/web/views/admin/products/product-form/TaxRateDialog.vue';

interface LocalState {
  fields: PaginatedTableField[];
  taxRates: TeacherTaxRateResponse[];
  loading: boolean;
}

export default Vue.extend({
  name: 'TaxRates',
  components: {
    TopNav,
    NavItem,
  },
  data(): LocalState {
    return {
      taxRates: [],
      loading: true,
      fields: [
        {
          title: this.$t('PRODUCTS.TAX_RATES.NAME') as string,
          name: 'name',
        },
        {
          title: this.$t('PRODUCTS.TAX_RATES.RATE') as string,
          name: 'rate',
        },
        {
          title: this.$t('PRODUCTS.TAX_RATES.STATUS') as string,
          name: 'status',
        },
        {
          name: 'edit',
          shrink: true,
          cssClass: 'p-0',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    editTaxRate(selectedTaxRate): void {
      this.$modal.show(TaxRateDialog, {
        taxRate: selectedTaxRate,
        onConfirm: async taxRate => {
          try {
            const updatedTaxRate = await this.$store.dispatch(
              'product/updateTeacherTaxRate',
              taxRate
            );
            const existingTR = this.taxRates.find(
              pp => pp.id === updatedTaxRate.id
            );
            if (existingTR) {
              this.$set(
                this.taxRates,
                this.taxRates.indexOf(existingTR),
                updatedTaxRate
              );
            } else {
              this.taxRates.push(updatedTaxRate);
            }
          } catch (error) {
            this.$notify({
              group: 'app',
              type: 'error',
              title: 'Failed to add a tax rate',
              text: errorToMessage(error?.response, `Request failed: ${error}`),
              duration: -1,
            });
          }
        },
      });
    },
    addTaxRate(): void {
      this.$modal.show(TaxRateDialog, {
        onConfirm: async taxRate => {
          try {
            const createdTaxRate = await this.$store.dispatch(
              'product/addTeacherTaxRate',
              taxRate
            );
            this.taxRates.push(createdTaxRate);
          } catch (error) {
            this.$notify({
              group: 'app',
              type: 'error',
              title: 'Failed to add a tax rate',
              text: errorToMessage(error?.response, `Request failed: ${error}`),
              duration: -1,
            });
          }
        },
      });
    },
    async loadData() {
      this.loading = true;
      try {
        this.taxRates = await this.$store.dispatch(
          'product/getTeacherTaxRates'
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load tax rates',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadData();
  },
});
